import {
  useGetPointElementOrderNumbersQuery,
  useGetSplineElementOrderNumbersQuery,
} from '@core/redux/query';
import { Chip, Stack, Typography } from '@mui/material';
import { isOrderNumberClosed } from '@projects/types/orderNumbers';
import { useGetSMAMappings } from '@projects/pages/detail/SmaNumbers/hooks';
import { useSelectedElements } from './ElementSelect/connect';

export const ElementSMADetails = () => {
  const { selectedPoints, selectedSplines, hasSelectedPoints, hasSelectedSplines } =
    useSelectedElements();
  const { data: pointElementOrderNumbers } = useGetPointElementOrderNumbersQuery(
    selectedPoints.at(0)?.id,
  );
  const { data: splineElementOrderNumbers } = useGetSplineElementOrderNumbersQuery(
    selectedSplines.at(0)?.id,
  );
  const { getSmaLabel } = useGetSMAMappings();

  if (!hasSelectedPoints && !hasSelectedSplines) {
    return null;
  }

  return (
    <Stack p={2} spacing={2}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="overline">SMA</Typography>
      </Stack>

      <Stack direction="row" flexWrap="wrap" gap={1}>
        {hasSelectedPoints &&
          pointElementOrderNumbers?.map((smaInfo) => {
            const closed = isOrderNumberClosed(smaInfo);
            const label = `${getSmaLabel(smaInfo.value)}${closed ? ' (Closed)' : ''}`;
            return (
              <Chip
                label={label}
                key={smaInfo.value}
                variant="outlined"
                sx={(theme) => ({
                  color: closed ? theme.palette.text.disabled : theme.palette.text.primary,
                  borderColor: closed ? theme.palette.text.disabled : theme.palette.divider,
                  backgroundColor: closed ? theme.palette.action.hover : 'transparent',
                  opacity: closed ? 0.7 : 1,
                })}
              />
            );
          })}
        {hasSelectedSplines &&
          splineElementOrderNumbers?.map((smaInfo) => {
            const closed = isOrderNumberClosed(smaInfo);
            const label = `${getSmaLabel(smaInfo.value)}${closed ? ' (Closed)' : ''}`;
            return (
              <Chip
                label={label}
                key={smaInfo.value}
                variant="outlined"
                sx={(theme) => ({
                  color: closed ? theme.palette.text.disabled : theme.palette.text.primary,
                  borderColor: closed ? theme.palette.text.disabled : theme.palette.divider,
                  backgroundColor: closed ? theme.palette.action.hover : 'transparent',
                  opacity: closed ? 0.7 : 1,
                })}
              />
            );
          })}
      </Stack>
    </Stack>
  );
};
